import React from "react";

import { ImageTextSplit } from "views";

function HomeLinkCards({ link_cards, maxWidth }) {
  return (
    <>
      {link_cards.map((item, index) => (
        <ImageTextSplit
          invert={index % 2 === 0}
          image={item.image}
          title={item.title}
          content={item.body}
          button_label={item.button_label}
          button_link={item.button_link}
          key={"homeLinkCard" + index}
        />
      ))}
    </>
  );
}

export default HomeLinkCards;
